import { render } from "./index.vue?vue&type=template&id=80319cc0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=80319cc0&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "80319cc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80319cc0', script)) {
    api.reload('80319cc0', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=80319cc0", () => {
    api.rerender('80319cc0', render)
  })

}

script.__file = "src/views/Settings/index.vue"

export default script